export default __webpack_public_path__ + "vision-safety-alerts-drawing-thumbnail-960-a151c335c36fbff0d80b14fccc9821e6.webp";